define(
    'viewmodels/viewmodel',[
        "durandal/system",
        "durandal/app",
        "durandal/activator",
        "plugins/router",
        "services/config",
        "services/log",
        "services/session",
        "services/eventbroker"
    ],
    function(system, app, activator, router, config, log, session, eventBroker) {

        function ViewModel(impl) {
            var self = this;

            self.app = app;
            self.system = system;
            self.config = config;
            self.log = log;
            self.session = session;
            self.eventBroker = eventBroker;
            self.deferredAttached = function () { return true; };
            self.deferredCompositionComplete = function () { return true; };
            self.codeBehind = null;
            if (impl) {

                if (_.has(impl, "attached")) {
                    self.deferredAttached = impl.attached;
                    delete impl.attached;
                }

                if (_.has(impl, "compositionComplete")) {
                    self.deferredCompositionComplete = impl.compositionComplete;
                    delete impl.compositionComplete;
                }

                $.extend(self, impl);
            }

            var codeBehindLoaded = $.Deferred();
            self.codeBehindLoaded = codeBehindLoaded.promise();

            
            // Defer anything event related, because we need to wait for Durandal to assign the module id.
            _.defer(function() {

                if (self.hasCodeBehind) {
                    // Presumes that we're using convention - should use the view locator ideally.
                    var codeBehindPath = system.getModuleId(self).replace("viewmodels", "views") + ".html";

                    require([codeBehindPath], function(codeBehind) {
                        self.codeBehind = codeBehind;
                        codeBehindLoaded.resolve();
                    });

                } else {
                    codeBehindLoaded.resolve();
                }


            });
        }

        ViewModel.prototype.attached = function() {
            var self = this;
            var dfd = $.Deferred();
            var args = _.toArray(arguments);

            self.codeBehindLoaded.done(function () {
                var resultOrPromise = self.deferredAttached();
                if (resultOrPromise) {
                    if (system.isPromise(resultOrPromise)) {
                        resultOrPromise.done(function () {
                            if (self.codeBehind && _.has(self.codeBehind, "attached")) {
                                self.codeBehind.attached.apply(self.codeBehind, args);
                            }
                            dfd.resolve();
                        });
                    } else {
                        if (self.codeBehind && _.has(self.codeBehind, "attached")) {
                            self.codeBehind.attached.apply(self.codeBehind, args);
                        }
                        dfd.resolve();
                    }
                };
            });

            return dfd.promise();
        };

        ViewModel.prototype.compositionComplete = function () {
            var self = this;
            var args = _.toArray(arguments);

            self.codeBehindLoaded.done(function () {
                var resultOrPromise = self.deferredCompositionComplete();
                if (resultOrPromise) {
                    if (system.isPromise(resultOrPromise)) {
                        resultOrPromise.done(function () {
                            if (self.codeBehind && _.has(self.codeBehind, "compositionComplete")) {
                                self.codeBehind.compositionComplete.apply(self.codeBehind, args);
                            }
                        });
                    } else {
                        if (self.codeBehind && _.has(self.codeBehind, "compositionComplete")) {
                            self.codeBehind.compositionComplete.apply(self.codeBehind, args);
                        }
                    }
                }
            });
        };


        return ViewModel;
    });
